import { ClientActiveStatus, ClientType, PaymentType } from './enums'

export class ClientInfo {
    active: ClientActiveStatus
    type: ClientType
    paymentType: PaymentType
    msaId: string
    roleId: string
    firstName: string
    lastName: string
    phone: string
    email: string
    starRating: number
    numberRating: number
    note: string
    avatar: string
    lastSeen: number
    username: string
    createDate: number
    modifyDate: number
    isTermsAccepted?: boolean
    isSmsOptedIn: boolean
    stripeAccount?: string
}



// WEBPACK FOOTER //
// ./src/types/ClientInfo.ts